import React from "react";

// DON'T DELETE THIS PAGE 
// OTHERWISE PANCHANG UI IS REMOVED... 
export default function Panchang() {
    return <></>;
}
